import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {Icon, Checkbox} from 'semantic-ui-react';
import {getSystemParameterValue} from '../../../common/util/parametersUtils';
import LiquidationsList from '../list';
import KpiLiquidationsByDays from '../kpiByDays';
import './slideshow.scss';

const CAROUSEL_ITEM = {
  'VEHICLES_LIST': 0,
  'PARTS_LIST': 1,
  'LIQUIDATIONS_KPI': 2,
};

const items = [
  {'index': CAROUSEL_ITEM.VEHICLES_LIST},
  {'index': CAROUSEL_ITEM.PARTS_LIST},
  {'index': CAROUSEL_ITEM.LIQUIDATIONS_KPI},
];
let timer = null;

class LiquitationsSlideShow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeItemIndex': 0,
      'autoPlay': false,
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.LiquidationsList, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
      return;
    }
    this.props.fetchSystemParameter('INTERVAL_REFRESH_IMPORTATIONS');
    this.props.fetchSystemParameter('INTERVAL_CHANGE_IMPORTATIONS_SLIDE');
    this.checkIfAutoPlay();
  }
 
  checkIfAutoPlay() {
    const {autoPlay} = this.state;
    if (!autoPlay) {
      this.stopTimer();
      return null;
    }
    this.startTimer();
  }

  startTimer() {
    const {systemParameters} = this.props;
    const intervalToChangeSlide = getSystemParameterValue(systemParameters, 'INTERVAL_CHANGE_IMPORTATIONS_SLIDE') || 60;

    timer = setInterval(() => {
      this.nextSlide();
    }, intervalToChangeSlide * 1000);
  }

  nextSlide() {
    const {activeItemIndex} = this.state;
    const lastItem = items.length - 1;
    const nextSlide = activeItemIndex >= lastItem ? 0 : activeItemIndex + 1;
    this.setState({'activeItemIndex': nextSlide});
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  stopTimer() {
    if (timer) {
      clearInterval(timer);
    }
  }

  changeActiveItem(activeItemIndex) {
    const {autoPlay} = this.state;
    if (!autoPlay) {
      this.setState({activeItemIndex});
      return;
    }
    this.setState({activeItemIndex}, () => {
      this.stopTimer();
      this.startTimer();
    });
  }

  render() {
    return (
      <div>
        {this.renderContent()}
        {this.renderControlersSection()}
      </div>
    );
  }
  
  renderContent() {
    const {activeItemIndex} = this.state;
    const {push} = this.props;
    switch (activeItemIndex) {
      default:
      case CAROUSEL_ITEM.VEHICLES_LIST:
        return <LiquidationsList push={push} type='vehicles' />;
      case CAROUSEL_ITEM.PARTS_LIST:
        return <LiquidationsList push={push} type='parts' />;
      case CAROUSEL_ITEM.LIQUIDATIONS_KPI:
        return <KpiLiquidationsByDays push={push} />;
    }
  }

  renderControlersSection() {
    const {autoPlay} = this.state;
    return (
      <div className='footersection'>
        <ul className='slidescontainer'>
          {this.renderControlerItem()}
        </ul>
        <div className='autoplaycontainer'>
          <div className='label'>Fijar</div>
          <Checkbox
            toggle
            defaultChecked={!autoPlay}
            onChange={this.autoPlayChange.bind(this)}
          />
        </div>
      </div>
    );
  }

  autoPlayChange(event, value) {
    this.setState({'autoPlay': !value.checked}, () => this.checkIfAutoPlay());
  }

  renderControlerItem() {
    const {activeItemIndex} = this.state;
    return items.map((element, key) => {
      const position = element.index;
      return (
        <li key={position} onClick={this.changeActiveItem.bind(this, position)}
          className={activeItemIndex === position ? 'active' : ''} >
          <Icon name='circle' size='small' color={activeItemIndex === position ? 'red' : 'black'} />
        </li>
      );
    });
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'systemParameters': state.parameters.list,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
  };
};

const {
  fetchSystemParameter,
  changeMenuVisibility,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  fetchSystemParameter,
  changeMenuVisibility,
})(LiquitationsSlideShow));
